var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 9.75C14.505 9.75 14.7525 9.78 15 9.8175V7.5C15 6.675 14.3325 6 13.5 6H12.75V4.5C12.75 2.43 11.07 0.75 9 0.75C6.93 0.75 5.25 2.43 5.25 4.5H6.75C6.75 3.255 7.755 2.25 9 2.25C10.245 2.25 11.25 3.255 11.25 4.5V6H4.5C3.6675 6 3 6.675 3 7.5V15C3 15.825 3.6675 16.5 4.5 16.5H10.3575C9.975 15.84 9.75 15.075 9.75 14.25C9.75 11.7675 11.7675 9.75 14.25 9.75ZM9 12.75C8.175 12.75 7.5 12.0825 7.5 11.25C7.5 10.4175 8.175 9.75 9 9.75C9.825 9.75 10.5 10.425 10.5 11.25C10.5 12.075 9.8325 12.75 9 12.75ZM16.875 12.9375L13.3125 16.5L11.25 14.25L12.12 13.38L13.3125 14.5725L16.005 11.88L16.875 12.9375Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.da6eb806.svg";
export { ForwardRef as ReactComponent };